module.exports = __webpack_public_path__ + "img/cloth_g1_shoe_02.cd12f4be.svg";